export default __webpack_public_path__ + "static/violation-58da51912e9c2593d8094ae8fb927d5f.png";